import { render, staticRenderFns } from "./restSuccess.vue?vue&type=template&id=45f177a7&scoped=true"
import script from "./restSuccess.vue?vue&type=script&lang=js"
export * from "./restSuccess.vue?vue&type=script&lang=js"
import style0 from "../assets/css/rest.less?vue&type=style&index=0&id=45f177a7&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f177a7",
  null
  
)

export default component.exports